export default "__VITE_PUBLIC_ASSET__5afed342__"